import { Component, OnDestroy, OnInit } from '@angular/core';
import {Config, getConfig, initialConfigState} from "../../../modules/redux";
import {Router} from "@angular/router";
import {Store} from "@ngrx/store";
import { AuthService } from 'src/app/services';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-auth-base',
  templateUrl: './auth-base.component.html',
  styleUrls: ['./auth-base.component.scss']
})
export class AuthBaseComponent implements OnDestroy {

  config:Config = initialConfigState;
  appEnvironment: string = environment.rondeivu_env_title;
  currentYear = new Date().getFullYear();
  
  constructor(
    private store:Store,
    private authService:AuthService
  ) {

    this.store.select(getConfig).subscribe((config:Config)=>{
      this.config = config;
    })
  }

  // Cleanup on component destroy
  ngOnDestroy() {
    // this ensures that the service forget the user login details, which includes the password!
    this.authService.ResetUserLoginDetails();
  }

  // Get current year for footer
  getYear() : string { return (new Date).getFullYear().toString(); }
}
